<template>
    <v-container fill-height style="height: 100vh; max-width: 100%!important; width: 100%!important; padding: 0!important; margin: 0px 0 0 0!important;" :class="$theme.baseBg">
        <v-toolbar
            v-if="!hideTitle"
            id="main-toolbar"
            height="52"
            app
            flat
            fixed
            dark
            :class="[$theme.toolbarBg]"
        >

            <template v-if="packageName==='com.denticalc.4in1'"><v-icon v-if="$router.currentRoute.name !== 'home'" @click="backBtnCb()" style="padding-right: 15px; margin-right: -10px;">chevron_left</v-icon></template>


            <v-toolbar-side-icon v-else style="border-radius: 0; margin-top: 0; margin-right: 0; margin-bottom: 0; margin-left: -15px; height: 50px; width: 60px;" @click.stop="$store.state.app.drawer = !$store.state.app.drawer" />

            <svg v-if="showWarning" style="pointer-events: none; filter: drop-shadow(1px 1px 0px #fff) drop-shadow(-1px 1px 0px #fff) drop-shadow(1px -1px 0px #fff) drop-shadow(-1px -1px 0px #fff); position: fixed; top: 10px; left: 10px; width:20px;height:20px" viewBox="0 0 24 24">
                <path fill="#e91e63" d="M13 14H11V9H13M13 18H11V16H13M1 21H23L12 2L1 21Z" />
            </svg>

            <slot name="mobile-toolbar">
                <v-toolbar-title><slot name="title" /></v-toolbar-title>
            </slot>
            <v-spacer v-if="!hideSidebar" />
            <v-toolbar-side-icon v-if="!hideSidebar" @click.stop="$store.state.app.drawerRight = !$store.state.app.drawerRight" />
        </v-toolbar>

        <v-content id="main-wrapper"
            :style="hideFooter ? 'padding: 0!important;' : 'padding: 0 0 72px!important;'"

        fill-height style="transition: 0s none!important; margin-top: 52px; height: calc(100vh - 52px)!important; padding-top: 0; width: 100%; overflow: hidden;" :class="$theme.baseBg">
            <div id="main-scrollable-content" style="height: 100%;" :style="barColor ? ('border-top: 5px solid '+barColor) : ''">
                <slot />
            </div>
        </v-content>

        <v-footer
            v-if="!hideFooter"
            app
            bottom
            flat
            fixed
            :class="$theme.contentBg"
            class="app-toolbar-footer"
            style="box-shadow: 0 0 20px rgba(0,0,0,.05);"
        >
            <slot name="toolbar">
                <pm-app-toolbar>
                    <template slot="prepend">
                        <slot name="toolbar-prepend" />
                    </template>
                    <template slot="append">
                        <slot name="toolbar-append" />
                    </template>
                </pm-app-toolbar>
            </slot>
        </v-footer>
    </v-container>
</template>

<style>
    html,
    body {
      position: fixed !important;
      overflow: hidden !important;
      height: 100vh !important;
      width: 100vw !important;
    }

    .blue-grey.darken-5 {
        background-color: #011111!important;
    }

    #main-wrapper {
        height: calc(100vh - 106px) !important;
    }

    .sidebar-bg-color {
        /*background: #d2eaf6!important;*/
    }
    .v-btn.v-btn--outline {
        border: none!important;
    }
    #pm-content-sidebar {
        /*background: #d2eaf6!important;*/
    }
    #pm-main-navigation .v-list__group__items--no-action .v-list__tile {
        padding-left: 16px;
        height: 44px !important;
    }

    #pm-main-navigation .v-list__group.v-list__group--active {
        padding-bottom: 16px;
    }

    #pm-main-navigation .v-list__group.v-list__group--active:before,
    #pm-main-navigation .v-list__group.v-list__group--active:after {
        display: none !important;
    }
    .toolbar--underlined .v-toolbar__content {
        padding: 0 16px;
        position: relative;
    }
    .toolbar--underlined .v-toolbar__content:after {
        content: '';
        display: block;
        position: absolute;
        height: 1px;
        left: 16px;
        right: 16px;
        bottom: 0;
        background: rgba(0,0,0,.08);
    }

.app-toolbar-footer {
    height: 72px !important;
}

#main-wrapper {

}

/* #main-wrapper {
    margin-top: 52px;
    height: calc(100vh - 52px) !important;
    padding-top: 0;
    width: 100%;
    overflow: hidden;
} */

#main-scrollable-content {
    overflow-x: hidden !important;
    overflow-y: auto !important;
}

@media (min-width: 700px) {
    #main-wrapper {
        margin-top: 52px !important;
        height: calc(100vh - 52px) !important;
        padding: 0px 0px 52px !important;
    }

    #main-toolbar {
        height: 52px !important;
    }

    #main-scrollable-content.ios {
        margin-top: 10px;
    }

    .app-toolbar-footer {
        height: 70px !important;
    }

    #main-toolbar .v-toolbar__content {
        height: 52px !important;
    }

    #main-toolbar *:not(span:nth-child(2)) {
        font-size: 22px !important;
    }

    #main-toolbar span:nth-child(2),
    #main-toolbar span.subtitle--premium,
    #main-toolbar span.subtitle--premium * {
        font-size: 14px !important;
    }
}
</style>

<script>
import pmAppToolbar from "./pm-app-toolbar.vue";

export default {
    components: {
        pmAppToolbar,
    },
    props: {
        hideTitle: {
            type: Boolean,
            default: false,
        },
        hideSidebar: {
            type: Boolean,
            default: false,
        },
        hideFooter: {
            type: Boolean,
            default: false,
        },
        barColor: {
            type: String,
            default: "",
        },
        backBtnCb: {
            type: Function,
            default: () => {
                app.$router.push('/');
            }
        },
    },
    provide: function() {
        return {
            getParent: this.$parent,
        };
    },
    data() {
        return({
            showWarning: false,
            packageName: window.packageName,
        });
    },
    created() {
        if (!window.packageName || window.packageName === "com.denticalc.calculationtool") {
            this.showWarning = localStorage.getItem('priceListVisited') !== "true" || !this.isTutorialViewed();

            this.registerBusEvent("mainMenu:update", () => {
                this.showWarning = localStorage.getItem('priceListVisited') !== "true" || !this.isTutorialViewed();

                this.$forceUpdate();
            });
        }
    },
    methods: {
        linkBack() {
            if (this.$listeners && this.$listeners.back) this.$emit("back");
            else this.$router.go(-1);
        },
        isTutorialViewed() {
            const t = parseFloat(localStorage.getItem('tutorialViewed'));
            if (isNaN(t)) return false;
            return t > 30;
        },
    },
};
</script>
